
let x = document.getElementsByClassName("message-tab");
const tabsCount = x.length;
let msgCurrentTab = 0

function showTab(n) {
  x[n].style.display = "block";
  if (n == 0) {
    document.getElementById("msg-prev-btn").style.display = "none";
  } else {
    document.getElementById("msg-prev-btn").style.display = "inline";
  }
  if (n == (x.length - 1)) {
    document.getElementById("msg-next-btn").style.display = "none";
  } else {
    document.getElementById("msg-next-btn").style.display = "inline";
  }

  fixStepIndicator(n)
}

function msgNextPrevTab(e, n) {
  if(e) e.preventDefault();

  if (n >= 1 && msgCurrentTab == 0 && $('#receiver-container:visible').length &&  $('#field-receiver').val() == '') {
    $('#receiver-prompt').show()
    return
  } else {
    $('#receiver-prompt').hide()
  }

  if (msgCurrentTab + n >= x.length) {
    return false;
  } else {
    x[msgCurrentTab].style.display = "none";
    msgCurrentTab = Math.max(0, Math.min(tabsCount - 1, Number(msgCurrentTab + n)));
  }
  showTab(msgCurrentTab);
}

function countChar(field, count, max){

  var length = $("#" + field).val().length;
  $("#" + count).text(length + "/" + max + " characters")
}

function fixStepIndicator(n) {
  var i, x = document.getElementsByClassName("vm-step");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  x[n].className += " active";
}

const class$ = str => document.getElementsByClassName(str);
const id$ = str => document.getElementById(str);
const screen_size = window.matchMedia('(max-width: 768px)')
let vmIframe = id$('virtual-message-app')
let popup = id$('virtual-message-popup')
let messageBox = id$('message')
let previewTextMsg = id$(`preview-message-text`)
var target;
var bngQrcode;
var vmUploaded;
var targetItem = 0;
var targetItemFile = '';
var messageValue = ''
var targetItemProps;
var targetQR;

toggleVMPopup = (e, el) => {
  if(e) e.preventDefault();
  if(el) targetItem = $(el).parents('.line-item-props').attr('id').slice(-1)
  if(!vmIframe.src){
    // vmIframe.src = 'http://localhost:3000/virtualmessage'
    vmIframe.src = 'https://app.giftr.my/virtualmessage'
  }

  targetItemProps = CartJS.cart.items[targetItem].properties

  if(popup.classList.contains('fading-in')){
    if ($('#message').val() && msgCurrentTab == 0 && $('#receiver-container:visible').length && $('#field-receiver').val() == '') {
      $('#receiver-prompt').show()
      return
    } else {
      $('#receiver-prompt').hide()
    }

    vmIframe.contentWindow.postMessage({ close_popup: true }, "https://app.giftr.my");

    msgNextPrevTab(undefined, -2)

    updateMessage()
  } else {

    showTab(msgCurrentTab)
    messageValue = targetItemProps['Message on Card']
    messageBox.value = messageValue

    targetItemFile = targetItemProps['Audio/Video Message']
    if(targetItemFile !== 'N/A'){
      vmUploaded = true
    }

    if (CartJS.cart.items[targetItem].vendor === 'Build & Gift') {
      $('#field-receiver').val(targetItemProps['Receiver'])
      $('#receiver-container').show()
      $('#message-area').css('margin-top', '10px')
      $('#vm-preview-default').hide()
      $('#vm-preview-bng').show()
      updatePreview({value: targetItemProps['Receiver']}, 'receiver-preview')
      updatePreview({value: messageValue}, 'bng-message-preview')
    } else {
      $('#receiver-container').hide()
      $('#message-area').css('margin-top', '1.5em')
      $('#vm-preview-default').show()
      $('#vm-preview-bng').hide()
      updatePreview()
    }

    if(screen_size.matches){
      window.history.pushState("forward", null, "")
    }
  }

  [id$('virtual-message-overlay'), popup].forEach(el => {
    el.classList.toggle('fading-in')
  })
}

$(window).on('popstate', e => {

  if(popup.classList.contains('fading-in')){
    vmIframe.contentWindow.postMessage({ close_popup: true }, "https://app.giftr.my");
    [id$('virtual-message-overlay'), popup].forEach(el => {
      el.classList.toggle('fading-in')
    })

    msgNextPrevTab(undefined, -2)

    updateMessage()
  }

})

window.addEventListener('message', e => {
  const { origin, data } = e;
  // if(origin !== 'http://localhost:3000'){
  if(origin !== 'https://app.giftr.my'){
    return
  }

 if(data && (data.fileUrl || data.skipAndSubmit)){
    const { fileUrl, skipAndSubmit } = data

    if(fileUrl){
      vmUploaded = true

      targetItemFile = fileUrl;

    } else if(skipAndSubmit){
      vmUploaded = false

      targetItemFile = 'N/A';

    }

    updatePreview()
    msgNextPrevTab(undefined, 1)

 }

 if(data && data.vmRecording){
    document.getElementById("msg-prev-btn").style.display = "none";
 } else {
    document.getElementById("msg-prev-btn").style.display = "inline";
 }

})

function receipientMessageChanged() {
  messageValue = messageBox.value;
  updatePreview();
}

if(messageBox){
  messageBox.addEventListener("input",receipientMessageChanged);
  id$("list").addEventListener("change",receipientMessageChanged);
}

function updatePreview(el, id){
  if (el && el.value && id) {
    $(`#${id}`).html(el.value);
  } else if(!messageValue && (!targetItemFile || targetItemFile === 'N/A')){
    previewTextMsg.innerHTML = 'Blank message card will be sent along with the gift'
  } else {
    previewTextMsg.innerHTML = messageValue
  }

  if(targetItemFile !== undefined){
    if(targetItemFile === 'N/A'){
      id$(`preview-qrcode-container`).style.display = 'none'
    } else {
      id$(`preview-qrcode-container`).style.display = 'block'
      id$(`preview-vm-qrcode`).href = targetItemFile;

      if (CartJS.cart.items[targetItem].vendor === 'Build & Gift') {
        if(!bngQrcode){
          bngQrcode = new QRCode(document.getElementById("bng-preview-vm-qrcode"), targetItemFile);
        } else {
          bngQrcode.clear();
          bngQrcode.makeCode(targetItemFile)
        }
        $('.message-block .qrcode-prompt').show();
      } else {
        if(!targetQR){
          targetQR = new QRCode(id$(`preview-vm-qrcode`), targetItemFile);
        } else {
          targetQR.clear();
          targetQR.makeCode(targetItemFile)
        }
      }
    }
  }

}

function updateMessage(){

  Shopify.getCart(cart => {
    let props = cart.items[targetItem].properties

    props['Message on Card'] = messageValue;
    props['Audio/Video Message'] = targetItemFile;

    if (cart.items[targetItem].vendor === 'Build & Gift') {
      props['Receiver'] = $('#field-receiver').val()
    }

    CartJS.updateItem(parseInt(targetItem)+1, cart.items[targetItem].quantity, props)
  })
}
